import ElementTemplate from '../ElementTemplate';

export class ContactElement extends ElementTemplate {
  closeBtn!: ElementTemplate<HTMLButtonElement>;

  constructor() {
    super(null, 'div', 'contact-modal');
    this.createModal();
  }

  createTitle() {
    const url = window.location.pathname;

    if (url.includes('/ru/')) {
      return 'Выберите способ связи';
    } else if (url.includes('/sr/')) {
      return 'Izaberite način kontakta';
    } else {
      return 'Choose contact method';
    }
  }

  createBookingLink() {
    const url = window.location.pathname;
    if (url.includes('/ru/')) {
      return 'Онлайн-запись';
    } else if (url.includes('/sr/')) {
      return 'Online rezervacija';
    } else {
      return 'Online booking';
    }

    // const bookingLink = new ElementTemplate(this.node, 'a', 'contact-modal__link');
    // bookingLink.node.setAttribute('href', 'https://schedule.palkin.rs/');
    // bookingLink.node.setAttribute('target', '_blank');
    // bookingLink.node.setAttribute('rel', 'noopener noreferrer');
    // bookingLink.node.textContent = 'Online booking';
  }

  createModal() {
    // Создаем оверлей
    new ElementTemplate(this.node, 'div', 'contact-modal__overlay');

    // Создаем контейнер содержимого
    const content = new ElementTemplate(this.node, 'div', 'contact-modal__content');

    // Заголовок
    new ElementTemplate(content.node, 'h3', 'contact-modal__title', this.createTitle());

    // Ссылки
    const links = new ElementTemplate(content.node, 'div', 'contact-modal__links');

    // Контакты
    const contacts = [
      // Для телефона используем отдельное изображение
      { href: 'https://schedule.palkin.rs/', icon: 'calendar-ico', text: this.createBookingLink() },
      { href: 'tel:+38169692323', icon: 'phone-ico', text: '+381 6969 2323' },
      { href: 'https://wa.me/38169692323', icon: 'whatsapp-ico', text: 'WhatsApp' },
      { href: 'https://t.me/palkin_clinic_bot', icon: 'telegram-ico', text: 'Telegram bot' },
      { href: 'https://t.me/palkindentalcenter', icon: 'telegram-ico', text: 'Telegram chat' },
      { href: 'viber://add?number=38169692323', icon: 'viber-ico', text: 'Viber' },
    ];

    // Создаем контакты
    contacts.forEach((contact) => this.createContactLink(links.node, contact));

    // Кнопка закрытия
    this.createCloseBtn(content.node);
  }

  createCloseBtn(parentNode: HTMLElement): void {
    this.closeBtn = new ElementTemplate<HTMLButtonElement>(parentNode, 'button', 'contact-modal__close');
    this.closeBtn.node.type = 'button';
  }

  private createContactLink(parentNode: HTMLElement, contact: { href: string; icon: string; text: string }): void {
    const link = new ElementTemplate(parentNode, 'a', 'contact-modal__link');
    if (contact.icon === 'calendar-ico') {
      link.node.setAttribute('target', '_blank');
      link.node.setAttribute('rel', 'nofollow');
    }
    link.node.setAttribute('href', contact.href);

    // Создаем SVG иконку
    const iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    iconSvg.classList.add('contact-modal__icon');
    iconSvg.setAttribute('width', '24');
    iconSvg.setAttribute('height', '24');

    const iconUse = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    iconUse.setAttribute('href', `../assets/svg/sprite.svg#${contact.icon}`);
    iconUse.setAttribute('x', '0');
    iconUse.setAttribute('y', '0');

    iconSvg.appendChild(iconUse);
    link.node.appendChild(iconSvg);

    // Текст ссылки
    new ElementTemplate(link.node, 'span', 'contact-modal__link-text', contact.text);
  }
}
